export const SubjectCategoryEnum = {
    TECHNICAL: 'TECHNICAL',
    HUMANITARIAN: 'HUMANITARIAN',
} as const;
export type SubjectCategoryEnum = (typeof SubjectCategoryEnum)[keyof typeof SubjectCategoryEnum];
